export default __webpack_public_path__ + "04ae6926ad40a624fcfba08e181741b9.png";